import { MixedYearLeaveApplicationPDFTemplate } from './MixedYearLeaveApplicationPDFTemplate';
import { SingleYearLeaveApplicationPDFTemplate } from './SingleYearLeaveApplicationPDFTemplate';
import { LeaveApplicationPDFRendererProps } from './types';

export const LeaveApplicationPDFRenderer = ({
  template,
  ...props
}: LeaveApplicationPDFRendererProps) => {
  if (template === 'mixed-year') {
    return <MixedYearLeaveApplicationPDFTemplate {...props} />;
  }

  return <SingleYearLeaveApplicationPDFTemplate {...props} />;
};
